<div
  class="card standalone fade change-password-component"
  [ngClass]="{
    'show': isReady()
  }"
>
  <div class="card-header text-center">
    <h1
      class="mb-0"
      *ngIf="isSetPassword"
    >
      {{'change-password.set-password-title'|translate}}
    </h1>
    <h1
      class="mb-0"
      *ngIf="!isSetPassword"
    >
      {{'change-password.title'|translate}}
    </h1>
  </div>
  <form
    [formGroup]="changePasswordForm"
  >
    <div class="card-body">

      <div
        app-form-input
        field="newPassword"
        label="{{'change-password.new-password.label'|translate}}"
        type="password"
        autocomplete="new-password"
        [isInvalid]="isFieldInvalid(changePasswordForm.get('newPassword'))"
        [isValid]="isFieldValid(changePasswordForm.get('newPassword'))"
      >
        <div
          app-form-input-feedback
          [type]="!isFieldInvalid(changePasswordForm.get('newPassword')) ? 'info' : 'invalid'"
        ><ng-container *ngIf="!isFieldInvalid(changePasswordForm.get('newPassword'))">{{'change-password.new-password.info'|translate}}</ng-container>
          <ng-container *ngIf="isFieldInvalid(changePasswordForm.get('newPassword')) && invalidNewPWD">{{'change-password.new-password.error-message.required-or-invalid'|translate}}</ng-container>
          <ng-container *ngIf="isFieldInvalid(changePasswordForm.get('newPassword')) && rejectedNewPWD">{{'change-password.new-password.error-message.rejected'|translate}}</ng-container>
        </div>
      </div>

      <div
        app-form-input
        field="confirmNewPassword"
        label="{{'change-password.confirm-password.label'|translate}}"
        type="password"
        autocomplete="new-password"
        [isInvalid]="isFieldInvalid(changePasswordForm.get('confirmNewPassword'))"
        [isValid]="isFieldValid(changePasswordForm.get('confirmNewPassword'))"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="isFieldInvalid(changePasswordForm.get('confirmNewPassword'))"
        >{{'change-password.confirm-password.error-message.required-or-invalid'|translate}}</div>
      </div>
      <hr *ngIf="hasError()" />
      <app-duke-alert
        data-test-submit-error-message
        type="danger"
        *ngIf="hasError()"
        alertClass="mb-0"
        dismissible="true"
        (open)="alertHandler.onOpen($event);"
        (close)="alertHandler.onClose($event); submitFailed = false;"
      >
        <p class="mb-0">
          {{'change-password.submit-error.message'|translate}}
        </p>
      </app-duke-alert>

      <app-authorize-action
        *ngIf="!!confirmChange"
        class="mb-4 mt-n3"
        [closeHandler]="closeConfirm"
        [submitHandler]="submit"
        [profile]="getProfile()"
        [error]="authorizationError"
      >
        <p>
          {{'change-password.confirm-password-change.info-paragraph'|translate}}
        </p>
      </app-authorize-action>
    </div>
    <div class="card-footer">
      <div class="d-flex align-items-center flex-row-reverse">
        <button
          *ngIf="isSetPassword"
          data-test-submit-btn
          class="btn btn-success"
          type="button"
          (click)="confirm()"
          [disabled]="!changePasswordForm.valid"
        >
          {{'change-password.set-password-change-button.label'|translate}}
        </button>
        <button
          *ngIf="!isSetPassword"
          data-test-submit-btn
          class="btn btn-success"
          type="button"
          (click)="confirm()"
          [disabled]="!changePasswordForm.valid"
        >
          {{'change-password.change-button.label'|translate}}
        </button>
        <span
          class="text-danger order-2 mr-2 text-right"
          *ngIf="hasError()"
          [@cardFooterFeedbackTransition]
          [@.disabled]="disableAnimations()"
        >
            <span class="icon fa fa-fw fa-exclamation-triangle"></span>
            <span>
              {{'change-password.submit-error.notification'|translate}}
            </span>
        </span>
        <a
          data-test-cancel-btn
          [routerLink]="getAppConstant('PATH_EDIT_PROFILE')"
          fragment="login"
          queryParamsHandling="merge"
          class="btn btn-secondary order-3 mr-auto"
        >
          {{'change-password.cancel-button.label'|translate}}
        </a>
      </div>
    </div>
  </form>
</div>
